// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"314":"setting","331":"boss","535":"login","676":"languages"}[chunkId] + "." + {"314":"13119870","331":"679aa6e1","535":"cac58904","676":"93ed3144"}[chunkId] + ".js";
};